<div class="flex flex-column justify-content-center align-items-center px-2 py-5">
  <div class="w-11 md:w-10 lg:w-7 xl:w-6">

    <h1 class="text-center mb-2">Contact us</h1>
    <p class="text-center text-muted mb-5">
      You are very welcome to contact us with any questions about
      <b>soil moisture validation</b>, <b>satellite data</b>, or
      the <b>QA4SM platform</b>.
      Whether you are a geophysicist, researcher, or simply curious about
      how satellite soil moisture data are evaluated — we'd be happy to hear from you.
    </p>

    <p-panel>
      <form class="p-fluid flex flex-column gap-5 pt-4" [formGroup]="contactForm" (ngSubmit)="onSubmit()">

        <!-- Email -->
        <p-floatLabel>
          <input pInputText
                 id="email"
                 formControlName="email"
                 class="w-full"
                 type="email"
                 autocomplete="email">
          <label for="email">
            <i class="pi pi-envelope mr-2"></i>E-mail address
          </label>
        </p-floatLabel>

        <!-- Name -->
        <p-floatLabel>
          <input pInputText
                 id="name"
                 formControlName="name"
                 class="w-full"
                 type="text"
                 autocomplete="name">
          <label for="name">
            <i class="pi pi-user mr-2"></i>Name
          </label>
        </p-floatLabel>

        <!-- Message -->
        <p-floatLabel>
          <textarea pInputTextarea
                    id="content"
                    formControlName="content"
                    class="w-full"
                    autocomplete="off"
                    rows="6">
          </textarea>
          <label for="content">
            <i class="pi pi-comment mr-2"></i>Message
          </label>
        </p-floatLabel>

        <!-- Checkbox -->
        <div class="flex align-items-center gap-2">
          <p-checkbox inputId="copy"
                      formControlName="send_copy_to_user"
                      [binary]="true">
          </p-checkbox>
          <label for="copy" class="cursor-pointer">Send a copy to me</label>
        </div>

        <!-- Honeypot slider -->
        <div class="flex flex-column gap-2">
          <label id="honeypotLabel" class="text-muted text-sm">
            <i class="pi pi-shield mr-2"></i>
            To prove you're a real person, slide the handle all the way to the right
            <i class="pi pi-angle-double-right ml-1"></i>
          </label>
          <p-slider
            id="honeypot"
            formControlName="honeypot"
            [min]="0" [max]="100" [step]="1"
            [attr.aria-labelledby]="'honeypotLabel'">
          </p-slider>
        </div>

        <!-- Submit -->
        <button pButton
                type="submit"
                label="Send message"
                icon="pi pi-send"
                iconPos="right"
                [disabled]="!contactForm.valid"
                class="w-full mt-2">
        </button>

      </form>
    </p-panel>

  </div>
</div>